import styled from '@emotion/styled'

import { spacing } from 'main/ui'

export const ReviewsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${spacing.majorScale(2)}px;

  > :not(:last-child) {
    margin-bottom: ${spacing.majorScale(2)}px;
  }
`
